import { useState, useEffect } from 'react';
import { CloseCircleFilled } from '@ant-design/icons';
import { ERROR_RED, WHITE } from "../../styles/styleUtils"

const CenteredPopup = ({ parentRef, message, visible }) => {
	const [position, setPosition] = useState({ top: 0, left: 0 });

	useEffect(() => {
		if (parentRef.current && visible) {
			const rect = parentRef.current.getBoundingClientRect();
			setPosition({
				top: rect.top + rect.height / 2 - 70,
				left: rect.left + rect.width / 2,
			});
		}
	}, [visible, parentRef]);

	if (!visible) return null;

	return (
		<div
			style={{
				position: 'fixed',
				top: position.top,
				left: position.left,
				transform: 'translate(-50%, -50%)',
				backgroundColor: '#ffe0e0',
				padding: '12px 20px',
				borderRadius: '4px',
				boxShadow: '0 0 8px rgba(0,0,0,0.5)',
				zIndex: 1000,
			}}
		>
			<div><CloseCircleFilled style={{ fontSize: '14px', color: ERROR_RED, paddingRight: '5px' }} /> {message}</div>
		</div>
	);
};


export default CenteredPopup;
